import { Map as hashMap } from 'immutable';

export const selectSystemStatus = (state: any) =>
  state.get('systemStatus', hashMap());
